import { GraphQLError } from 'graphql';

import { AppointmentMode } from '__generated__/globalTypes';
import { createMockResponse } from '../../../../../Test/graphqlMocks';
import { CREATE_APPOINTMENT } from './useCreateAppointment';
import type { createAppointmentVariables } from './__generated__/createAppointment';

export const ServiceTypeIDs: Record<string, number> = {
  COUNSELLING: 12,
  PRACTICAL_SUPPORT: 45,
  LIFE_COACHING: 7,
  WELLNESS_COACHING: 8,
  TOBACCO_CESSATION: 9,
} as const;

const query = CREATE_APPOINTMENT;
const variables: createAppointmentVariables = {
  counsellorId: '46',
  date: '2025-01-01',
  time: '14:30:00',
  serviceId: String(ServiceTypeIDs.WELLNESS_COACHING),
  emailAddress: 'user@example.com',
  phoneNumber: '+447123456789',
  filters: {
    appointmentMode: AppointmentMode.PHONE,
    languages: ['5'],
    timeZone: 'Europe/London',
  },
};

export const mockCreateAppointment = createMockResponse({
  query,
  variables,
  data: {
    createAppointment: {
      __typename: 'CreateAppointment',
      id: '12345',
      dateFrom: '2025-01-01T11:00:00Z',
    },
  },
});

export const mockCreateAppointmentError = createMockResponse({
  query,
  variables,
  errors: [new GraphQLError('Something went wrong')],
});
export const mockCreateAppointmentTOError = createMockResponse({
  query,
  variables,
  errors: [new GraphQLError('Timeout error')],
});
export const mockCreateAppointmentDuplicateError = createMockResponse({
  query,
  variables,
  errors: [
    new GraphQLError(
      'You have already added an appointment for this session.',
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      {
        code: 'WPO_APPOINTMENT_CREATION_FAILED_DUPLICATE',
      },
    ),
  ],
});
